import axios from "axios/index";
import * as constants from "@/common/constants";
import SecureModel from "@/models/secureModel";

const secureModel = new SecureModel();

class GeneralApiService {
  constructor() {
    this.axios = axios;
    this.apiIdentityUrl = process.env.VUE_APP_ENV_IDENTITY_API_URL || "";
    this.publicIdentityUrl = this.apiIdentityUrl.replace("/api", "/public");
    this.lastPrivateRequestParams = {
      method: "",
      route: "",
      payload: ""
    };
  }

  /**
   * @param {String} route
   * @param {Object} payload
   **/
  publicPostRequest(route, payload) {
    return this.axios({
      url: route,
      data: payload,
      method: "POST"
    })
      .then(response => {
        if (response && response.data) {
          return {
            success: response.status === 200,
            code: response.status,
            message: response.statusText,
            body: response.data
          };
        } else {
          throw Error(constants.ERROR_BAD_SERVER);
        }
      })
      .catch(err => {
        if (err.response.status === 400) {
          throw err;
        } else if (err.response.data && err.response.data.message) {
          throw Error(err.response.data.message);
        } else {
          throw Error(constants.ERROR_UNKNOWN);
        }
      });
  }

  /**
   *
   * @param {String} method
   * @param {String} route
   * @param {{}} payload
   * @param {String} payload.query
   * @param {{}} payload.body
   * @returns {Promise<AxiosResponse<any>>}
   */
  privateRequest(method, route, payload) {
    this.lastPrivateRequestParams = {
      method,
      route,
      payload
    };

    const { query, body } = payload;
    let axiosPayload = {
      url: route + (query ? query : ""),
      headers: {
        Authorization: "Bearer " + secureModel.getAccessToken()
      },
      method: method
    };
    if (body) {
      axiosPayload.data = {
        ...body
      };
    }
    return this.axios(axiosPayload)
      .then(response => {
        if (response && response.data) {
          return {
            success: response.status === 200,
            code: response.status,
            message: response.statusText,
            body: response.data
          };
        } else {
          throw Error(constants.ERROR_BAD_SERVER);
        }
      })
      .catch(err => {
        switch (err.response.status) {
          case 400:
            throw err.response.data;
          case 401:
            return this.refreshToken()
              .then(response => {
                this.axios.defaults.headers.common["Authorization"] =
                  response.body.access_token;
                return response;
              })
              .then(() => {
                return this.privateRequest(
                  this.lastPrivateRequestParams.method,
                  this.lastPrivateRequestParams.route,
                  this.lastPrivateRequestParams.payload
                );
              })
              .catch(() => {
                secureModel.setSecureData({});
                window.location.href =
                  process.env.VUE_APP_ENV_LOGIN_URL + "/login";
              });
          default:
            throw Error(constants.ERROR_UNKNOWN);
        }
      });
  }

  /**
   *
   */
  keepAlive() {
    return this.privateRequest(
      "POST",
      this.apiIdentityUrl + constants.API_KEEP_ALIVE,
      {}
    ).then(response => {
      return response && response.body ? response.body : {};
    });
  }

  /**
   *
   */
  refreshToken() {
    return this.publicPostRequest(
      this.publicIdentityUrl + constants.API_REFRESH_TOKEN,
      {
        refresh_token: secureModel.getRefreshToken()
      }
    ).then(response => {
      const secureData = response.body;
      if (secureData.access_token && secureData.refresh_token) {
        secureModel.setSecureData({
          accessToken: secureData.access_token,
          refreshToken: secureData.refresh_token
        });
      }

      return response;
    });
  }
}

export default GeneralApiService;
